module.exports = __webpack_public_path__ + "img/Certop_TR_ISO_IEC_27001_ISO_IEC_27017_hun.e68e37f8.jpg";